import React from 'react'
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { NotFound } from '@/pages/NotFound'
import { Hoy } from '@/pages/Hoy'
import { Relaciones } from '@/pages/Relaciones'
import { RelacionDetalle } from '@/pages/RelacionDetalle'
import { Personas } from '@/pages/Personas'
import { PersonaDetalle } from '@/pages/PersonaDetalle'
import { Iniciativas } from '@/pages/Iniciativas'
import { IniciativaDetalle } from '@/pages/IniciativaDetalle'
import { Configuracion } from '@/pages/Configuracion'
import { Usuarios } from '@/pages/Usuarios'
import { Onboarding } from '@/pages/Onboarding'

// AuthGate in App.tsx guarantees a valid Microsoft session before the router
// renders, so no ProtectedRoute is needed here.
const AppRoutes: React.FC = () => <Outlet />

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppRoutes />,
    children: [
      {
        path: '',
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/hoy" replace /> },
          { path: 'hoy', element: <Hoy /> },
          { path: 'relaciones', element: <Relaciones /> },
          { path: 'relaciones/:relationshipId', element: <RelacionDetalle /> },
          { path: 'personas', element: <Personas /> },
          { path: 'personas/:personId', element: <PersonaDetalle /> },
          { path: 'iniciativas', element: <Iniciativas /> },
          { path: 'iniciativas/:initiativeId', element: <IniciativaDetalle /> },
          { path: 'configuracion', element: <Configuracion /> },
          { path: 'usuarios', element: <Usuarios /> },
          { path: 'empresas', element: <Navigate to="/relaciones" replace /> },
          { path: 'contactos', element: <Navigate to="/personas" replace /> },
          { path: 'onboarding', element: <Onboarding /> },
          { path: 'settings', element: <Navigate to="/configuracion" replace /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
])
